'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userAddressDetails = require('./user-address-details.html');

var _userAddressDetails2 = _interopRequireDefault(_userAddressDetails);

var _userAddressDetails3 = require('./user-address-details.controller');

var _userAddressDetails4 = _interopRequireDefault(_userAddressDetails3);

require('./user-address-details.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userAddressDetailsComponent = {
  restrict: 'E',
  bindings: {
    address: '<'
  },
  template: _userAddressDetails2.default,
  controller: _userAddressDetails4.default,
  controllerAs: 'vm'
};

exports.default = userAddressDetailsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-address-details/user-address-details.component.js
 **/